import { CharClass, LanguageClass } from "./util-text-classes.js";
import { createWbr, createThinSpace } from "./util-tags.js";
import { middleDotsRegex, whitespaceRegex } from "./util-regex.js";
import { canBreakBetween } from "./line-break.js";
const insertSeparatorsToText = (currentText, nextText, options) => {
  const currentSegments = createSegments(currentText);
  const nextSegments = createSegments(nextText);
  const formattedText = currentSegments.reduce((accumulatedText, segment, index, array) => {
    const current = segment;
    const next = array[index + 1] || nextSegments[0];
    return accumulatedText + addSeparatorsToSegment(current, next, options);
  }, "");
  return formattedText;
};
let segmenter;
const createSegments = (src) => {
  segmenter ?? (segmenter = new Intl.Segmenter("ja-JP", { granularity: "word" }));
  return Array.from(segmenter.segment(src), ({ segment }) => segment);
};
const addSeparatorsToSegment = (current, next = "", options) => {
  if (!next) return current;
  const addThinSpace = options.insertThinSpaces && shouldAddThinSpace(current, next);
  const breakable = isBreakable(current, next);
  if (addThinSpace) {
    const hasMiddleDots = middleDotsRegex.test(current) || middleDotsRegex.test(next);
    const thinSpaceWidth = hasMiddleDots ? `calc(${options.thinSpaceWidth} / 2.0)` : options.thinSpaceWidth ?? "";
    return current + createThinSpace(thinSpaceWidth, breakable);
  }
  if (options.useWordBreak && breakable) {
    return current + createWbr();
  }
  return current;
};
const shouldAddThinSpace = (current, next) => {
  if (whitespaceRegex.test(current) || whitespaceRegex.test(next)) return false;
  return CharClass.includesPunctuation(current, next) ? CharClass.shouldAddThinSpace(current, next) : LanguageClass.shouldAddThinSpace(current, next);
};
const isBreakable = (current, next) => {
  const currentChar = Array.from(current).at(-1) ?? "";
  const nextChar = Array.from(next)[0] ?? "";
  if (!currentChar || !nextChar) return false;
  if (whitespaceRegex.test(nextChar)) return false;
  if (canBreakBetween(currentChar, nextChar)) return true;
  return LanguageClass.canBreakAcrossScripts(currentChar, nextChar);
};
var insert_separators_default = insertSeparatorsToText;
export {
  addSeparatorsToSegment,
  createSegments,
  insert_separators_default as default,
  isBreakable,
  shouldAddThinSpace
};
